"use client";

import { useRef, useEffect, useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

const BestShots = () => {
  const images = [
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042755/tmp9y788j31_1_aq4sqs.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042754/image-1746615860464_1_xttl78.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042754/tmp0432d1bq_1_bm5yjg.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042754/tmpz6wi_z79_1_sgqkpn.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747043242/tmpepkxl0mj_1_1_dsef06.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747043242/tmpfo2ofn7i_1_tkls3c.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1748594838/ChatGPT_Image_May_30_2025_01_09_41_PM_yjssyg.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1748594838/ChatGPT_Image_May_30_2025_01_16_14_PM_likn0r.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042754/tmp8b7wycgw_1_m9hjpv.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042755/tmp_vy53enu_1_wtd360.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042754/tmpld89wsc1_1_lacnlo.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747042754/tmpzxd7imdg_1_yizaew.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743247/image-1747742642104_qfkjs5.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743248/image-1747742607609_smd8hu.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743248/image-1747741608506_xefdej.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743248/image-1747741504662_umczfz.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743248/image-1747741711873_r62ts4.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743248/image-1747741542030_gg2rwo.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743249/image-1747740529945_aorp9e.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743249/image-1747740266466_mcavan.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743249/image-1747742762938_v4sbjm.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743249/image-1747740487990_i7x1fq.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743250/image-1747740146182_ectmrq.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747743251/image-1747740206377_m5vtge.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836277/image_63_hs9gzt.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836277/image_66_bxu3r9.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836277/image_64_zuwepu.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836277/image_62_rns7dg.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1748594838/ChatGPT_Image_May_30_2025_01_16_14_PM_likn0r.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836278/image_65_o5m6nh.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836277/image_68_k3jb5w.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836277/image_64_zuwepu.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836278/image_67_umxzfw.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836278/image_60_zjxfbu.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836278/image_69_upecod.webp",
    "https://res.cloudinary.com/dcyrpk68d/image/upload/v1747836278/image_61_mrux6u.webp",
  ];

  return (
    <section
      className="flex w-full max-w-screen flex-col items-center justify-start gap-5 overflow-hidden py-[30px] md:gap-[70px] md:py-[50px]"
      aria-label="Best Shots Gallery"
    >
      <div className="flex w-full flex-col items-center justify-center gap-[15px] px-10 py-2.5 md:gap-3">
        <h2 className="text-center text-xl font-medium md:text-[38px] md:font-semibold">
          Find the{" "}
          <span className="bg-gradient-to-b from-[#6CB5FF] to-[#1E7BDB] bg-clip-text text-transparent">
            Best Models
          </span>{" "}
          for your use case
        </h2>
        <p className="text-center text-sm font-medium text-[#B3B3B3] max-md:max-w-[280px] md:text-[22px]">
          Easy to create the best output when you have all the AI models in a
          single platform.
        </p>
      </div>

      <div className="relative w-full overflow-hidden">
        {/* First row of images */}
        <InfiniteMovingImages
          items={images.slice(0, 12)}
          direction="left"
          speed="slow"
          pauseOnHover={false}
        />

        {/* Second row of images */}
        <div className="mt-2.5 w-full md:mt-[27px]">
          <InfiniteMovingImages
            items={images.slice(12, 24)}
            direction="right"
            speed="slow"
            pauseOnHover={false}
          />
        </div>

        {/* third row of images (mobile only) */}
        <div className="mt-2.5 w-full md:mt-[27px] md:hidden">
          <InfiniteMovingImages
            items={images.slice(24, 36)}
            direction="left"
            speed="slow"
            pauseOnHover={false}
          />
        </div>

        {/* Gradient overlays */}
        <div className="pointer-events-none absolute top-0 left-0 h-full w-[38px] bg-gradient-to-r from-black to-black/0 opacity-90 md:w-[232px]" />
        <div className="pointer-events-none absolute top-0 right-0 h-full w-[38px] bg-gradient-to-r from-black/0 to-black opacity-90 md:w-[232px]" />
      </div>
    </section>
  );
};

export default BestShots;

const InfiniteMovingImages = ({
  items,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
}: {
  items: string[];
  direction?: "left" | "right";
  speed?: "fast" | "normal" | "slow";
  pauseOnHover?: boolean;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<HTMLUListElement>(null);

  const [start, setStart] = useState(false);

  useEffect(() => {
    const getDirection = () => {
      if (containerRef.current) {
        if (direction === "left") {
          containerRef.current.style.setProperty(
            "--animation-direction",
            "forwards"
          );
        } else {
          containerRef.current.style.setProperty(
            "--animation-direction",
            "reverse"
          );
        }
      }
    };

    const getSpeed = () => {
      if (containerRef.current) {
        if (speed === "fast") {
          containerRef.current.style.setProperty("--animation-duration", "20s");
        } else if (speed === "normal") {
          containerRef.current.style.setProperty("--animation-duration", "40s");
        } else {
          containerRef.current.style.setProperty(
            "--animation-duration",
            "200s"
          );
        }
      }
    };

    function addAnimation() {
      if (containerRef.current && scrollerRef.current) {
        const scrollerContent = Array.from(scrollerRef.current.children);

        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          if (scrollerRef.current) {
            scrollerRef.current.appendChild(duplicatedItem);
          }
        });

        getDirection();
        getSpeed();
        setStart(true);
      }
    }

    addAnimation();
  }, [direction, speed]);

  return (
    <div
      ref={containerRef}
      className={cn("scroller relative z-20 overflow-hidden")}
    >
      <ul
        ref={scrollerRef}
        className={cn(
          "flex w-max min-w-full shrink-0 flex-nowrap gap-1.5 md:gap-5",
          start && "animate-scroll",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {items.map((item, index) => (
          <div
            key={`top-${index}`}
            className="top-image-item aspect-square size-[130px] flex-shrink-0 md:size-[300px]"
            tabIndex={0}
            aria-label={`Best shot image ${index + 1}`}
          >
            <Image
              src={item || "/placeholder.svg"}
              alt={`Best shot ${index + 1}`}
              width={300}
              height={300}
              className="size-[130px] rounded-xs object-cover md:size-[300px] md:rounded-xl"
              loading="lazy"
            />
          </div>
        ))}
      </ul>
    </div>
  );
};
